module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"users":{"profile":{"contact_modal":{"action":"Kontaktdaten ergänzen","address":"Adresse:","company":"Firma:","modal_title_html":"Adresse und Kontaktdaten<br>von %{name}","phone":"Telefon:","send_message":"Nachricht senden","show_phone":"Telefonnummer anzeigen","zipcode":"Postleitzahl:"}}}}}}}')
  delete Component.options._Ctor
}
